import { useQuery } from "@tanstack/react-query"

import { TraceabilityResponses } from "@tfg/types/endpoints/traceability"

import { httpClient } from "~/backend/axios"
import { useAuth } from "~/store/auth-context"

export const useGetTraceabilityRequestsStats = () => {
  const { user } = useAuth()
  return useQuery({
    queryKey: ["traceabilityRequestsStats", user?.id],
    queryFn: async () =>
      (
        await httpClient.get<TraceabilityResponses.Stats>(
          "/traceability-requests/stats"
        )
      ).data,
  })
}
